<!-- eslint-disable -->
<template>
  <v-card height="100%">
    <v-card-text>
      <v-row>
        <v-col cols="12" md="4">
          <v-btn
            small
            color="info"
            class="mt-5 ml-3"
            @click="getAll"
            :disabled="loader"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-btn
            small
            color="success"
            class="mt-5 ml-3"
            :disabled="loader"
            @click="nuevo"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" xl="4" offset-xl="4">
          <v-container>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Busqueda"
              single-line
              hide-details
            />
          </v-container>
        </v-col>
      </v-row>
      <v-data-table
        dense
        :items-per-page="perPage"
        :headers="headers"
        :items="items"
        :item-class="row_classes"
        class="elevation-1"
        :search.sync="search"
        mobile-breakpoint="0"
      >
        <template v-slot:[`item.importe`]="{ item }">
          {{ item.importe | moneda }}
        </template>
        <template v-slot:[`item.iva`]="{ item }">
          {{ item.iva | moneda }}
        </template>
        <template v-slot:[`item.retencion`]="{ item }">
          {{ item.retencion | moneda }}
        </template>
        <template v-slot:[`item.total`]="{ item }">
          {{ item.total | moneda }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <template v-if="item.deleted_at">
            <v-btn icon color="success" @click="restaurar(item)">
              <v-icon>mdi-delete-restore</v-icon>
            </v-btn>
          </template>
          <template v-else>
            <v-btn icon color="success" @click="editar(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon color="error" @click="eliminar(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "Tarifas",
  data: () => ({
    headers: [
      { text: "Nombre del Transportista", value: "nombre" },
      { text: "Municipios", value: "lista_municipios" },
      { text: "Importe", value: "importe", align: "end" },
      { text: "IVA", value: "iva", align: "end" },
      { text: "Retención IVA", value: "retencion", align: "end" },
      { text: "Total", value: "total", align: "end" },
      { text: "Acciones", value: "actions", align: "end" }
    ],
    search: undefined,
    perPage: 15
  }),
  computed: {
    ...mapState({
      items: state => state.Tarifas.collection,
      loader: state => state.Tarifas.loader
    })
  },
  mounted() {
    if (!this.items) this.getAll();
  },
  methods: {
    ...mapActions("Tarifas", [
      "getAll",
      "nuevo",
      "editar",
      "deshabilitar",
      "habilitar"
    ]),
    eliminar(item) {
      let pregunta = `¿Deshabilitar la tarifa ${item.nombre}?`;
      window
        .swal({
          title: pregunta,
          icon: "warning",
          buttons: ["Cancelar", "Confirmar"],
          dangerMode: true
        })
        .then(confirmed => {
          if (confirmed) {
            this.deshabilitar(item.id);
          }
        });
    },
    restaurar(item) {
      let pregunta = `¿Habilitar la tarifa ${item.nombre}?`;
      window
        .swal({
          title: pregunta,
          icon: "warning",
          buttons: ["Cancelar", "Confirmar"],
          dangerMode: true
        })
        .then(confirmed => {
          if (confirmed) {
            this.habilitar(item.id);
          }
        });
    }
  }
};
</script>
